export function getPriceVariance(
    currentPrice: number | null | undefined,
    proposedPrice: number | null | undefined,
): number | null {
    if (
        currentPrice == null ||
        currentPrice === 0 ||
        !Number.isFinite(currentPrice)
    ) {
        return null;
    }
    const proposed = proposedPrice ?? 0;
    return (currentPrice - proposed) / currentPrice;
}
